/**
 * Enum for aria-disabled attribute values.
 */
export enum AriaDisabled {
  True = 'true',
  False = 'false',
}
